import React, { Suspense, useState, useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { router } from "./component/routes/router";
import Loader from "./component/loader/loader";
import { PlayerProvider } from "./PlayerContext";
import { ProfileProvider } from "./context";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";

const App = () => {
  const [isApiLoading, setIsApiLoading] = useState(false);

  useEffect(() => {
    const handleApiLoading = (event) => {
      setIsApiLoading(event.detail?.loading || false);
    };

    window.addEventListener("apiLoading", handleApiLoading);
    return () => {
      window.removeEventListener("apiLoading", handleApiLoading);
    };
  }, []);

  return (
    <PayPalScriptProvider
      options={{
        "client-id":
          "AXtfM0Y5E7itgx0_UR5hSpo92oxsRGWiKjlrEslUJN3uLttz9SbNz_mF0cXcod7-cJkZsp4o5H1RwYVq",
        currency: "USD",
        intent: "capture",
      }}
    >
      <PlayerProvider>
        <ProfileProvider>
          <Suspense>
            <RouterProvider router={router} />
          </Suspense>

          {/* Global API Loader */}
          {isApiLoading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
              }}
            >
              <div className="d-flex flex-column align-items-center">
                <div
                  className="spinner-border text-primary"
                  role="status"
                  style={{ width: "3rem", height: "3rem" }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-white mt-3">Processing...</p>
              </div>
            </div>
          )}

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </ProfileProvider>
      </PlayerProvider>
    </PayPalScriptProvider>
  );
};

export default App;
